import { useEffect } from "react";
import { Alert, Button, Col, Row } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiCheckboxBlankOutline, mdiCheckboxMarkedOutline } from "@mdi/js";

import { CriteriaClassificationEntity } from "src/entities/CriteriaClassificationEntity";

type ClassificationsStepProps = {
	options: CriteriaClassificationEntity[];
	selectedOptions: CriteriaClassificationEntity[];
	onChange: (selectedOptions: CriteriaClassificationEntity[]) => void;
	onCanAdvanceChange: (canAdvance: boolean) => void;
};

export default function ClassificationsStep({ options, selectedOptions, onChange, onCanAdvanceChange }: ClassificationsStepProps) {
	useEffect(() => {
		onCanAdvanceChange(true);
	}, [onCanAdvanceChange]);

	function handleToggle(classification: CriteriaClassificationEntity) {
		onChange(
			selectedOptions.some((option) => option.id === classification.id)
				? selectedOptions.filter((option) => option.id !== classification.id)
				: [...selectedOptions, classification]
		);
	}

	if (options.length === 0) {
		return <Alert variant="light">Nenhuma classificação vinculada ao critério.</Alert>;
	}

	return (
		<Row className="w-100">
			{options.map((classification) => {
				const checked = selectedOptions.some((option) => option.id === classification.id);

				return (
					<Col key={classification.id} md={12} className="mb-2">
						<Button
							type="button"
							variant="outline-dark"
							className={`d-flex align-items-center w-100 gap-3 rounded-3 border text-start h-100 ${checked ? "active" : ""}`}
							onClick={() => handleToggle(classification)}
						>
							<div>
								<Icon path={checked ? mdiCheckboxMarkedOutline : mdiCheckboxBlankOutline} size={1} />
							</div>
							{classification.title}
						</Button>
					</Col>
				);
			})}
		</Row>
	);
}
